import Icon from "@ant-design/icons"
import React from "react"

const undoneSvg = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3536 0.646447C11.1583 0.451184 10.8417 0.451184 10.6464 0.646447L6 5.29289L1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L5.29289 6L0.646447 10.6464C0.451184 10.8417 0.451184 11.1583 0.646447 11.3536C0.841709 11.5488 1.15829 11.5488 1.35355 11.3536L6 6.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6464L6.70711 6L11.3536 1.35355C11.5488 1.15829 11.5488 0.841709 11.3536 0.646447Z"
            fill="#F95D8F"
        />
    </svg>
)

const UndoneIcon = (props: any) => <Icon component={undoneSvg} {...props} />

export default UndoneIcon
